/* eslint-disable max-len */
import React from 'react';
import img3enfants from '../../static/images/section1-presentation/troisEnfants.jpg';

export const Section1Presentation = () => (

  <section id="section1-presentation" className="py-8 mb-0">
    <div className="grey" />
    <div className="white" />
    <div className="principal pt-8 pb-4">
      <div className="flex flex-col md:flex-row justify-center items-center">
        <div className="relative w-full md:w-2/3">
          <div className="trais hidden md:block" />
          <img src={img3enfants} className="img-3-enfants w-full" />
        </div>
        <div className="content_texte1 w-full md:w-1/3">
          <h2>Présentation du projet</h2>
          <p>
            <a href="https://www.dei-belgique.be/index.php/projets/en-cours/bridge.html">BRIDGE</a>
            , démarré en 2019, a pour objectif de renforcer la réponse à la VBG en Europe avec 3 moyens d’actions&nbsp;:
          </p>
          <br />
          <ul>
            <li>La collecte de données</li>
            <li>Le renforcement des capacités des professionnel·le·s de l’accueil</li>
            <li>La sensibilisation des enfants et des jeunes migrant·e·s.</li>
          </ul>
          <br />
          <p>
            Pour en savoir plus sur BRIDGE, rendez-vous sur notre
            {' '}
            <a href="https://www.dei-belgique.be/index.php/projets/en-cours/bridge.html" target="_blank">site internet</a>
            .
          </p>
        </div>
      </div>
      <div className="content_texte2 mt-8">
        <h2>Pourquoi est-ce important ? </h2>
        <p className="mb-8">Les enfants migrant·e·s sont particulièrement vulnérables à la violence basée sur le genre (VBG) tant dans le pays d’origine, pendant leur trajet migratoire que dans les pays de transit ou de destination. Lutter contre ce phénomène, c’est protéger les enfants des violences et discriminations liées au genre, mais aussi avancer vers une société plus égalitaire et respectueuse des droits de tous les enfants.</p>

        <h2>Le genre et la VBG, qu’est-ce que c’est&nbsp;?</h2>
        <p>
          Alors que le sexe désigne les caractéristiques biologiques des hommes et des femmes, le genre est la différence socialement construite entre les hommes et les femmes. Divers éléments tels que l’âge, la culture, le milieu socio-économique, la religion, etc. influencent le genre et son expression.
          <br />
          <br />
          La violence basée sur le genre (VBG) désigne toute forme de violence commise contre un individu en raison de son genre. Elle comprend par exemple des agressions physiques, sexuelles et psychologiques, le mariage précoce et forcé, la privation de liberté et de ressources. Les VBG concernent tous les individus. Cependant, les filles et les femmes sont davantage victimes de VBG.
        </p>
      </div>
    </div>
  </section>
);
